import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import './css/element-cover.css'
import request from '@/util/request'
import store from './store'

Vue.prototype.$axios = request
Vue.config.productionTip = false

Vue.directive('focus', {
  // 当被绑定的元素插入到 DOM 中时……
  inserted: function (el) {
    // 聚焦元素
    el.focus()
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
